import { createTheme } from "@mui/material/styles";
import { palettes } from "./palletes";

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xs: false; // removes the `xs` breakpoint
    sm: false;
    md: false;
    lg: false;
    xl: false;
    mobile: true; // adds the `mobile` breakpoint
    tablet: true;
    laptop: true;
    desktop: true;
  }
}

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: palettes.$primaryColor,
      light: palettes.$primaryLight,
    },
    secondary: { main: palettes.$secondaryColor },
    background: {
      default: palettes.$backgroundColor,
    },
    text: {
      primary: palettes.$primaryTextColor,
      secondary: palettes.$secondaryTextColor,
      disabled: palettes.$placeholderTextColor,
    },
    success: { main: palettes.$success },
    warning: { main: palettes.$warning },
    error: { main: palettes.$danger },
    info: { main: palettes.$info },
  },
  typography: {
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 14,
    h1: {
      fontSize: "32px", // 2rem
    },
    h2: {
      fontSize: "28px", // 1.75rem
    },
    h3: {
      fontSize: "24px", // 1.5rem
    },
    h4: {
      fontSize: "20px", // 1.25rem
    },
    h5: {
      fontSize: "16px", // 1rem
    },
    h6: {
      fontSize: "14px", // 0.875rem
    },
    body1: {
      fontSize: "16px", // 1rem
    },
    body2: {
      fontSize: "14px", // 0.875rem
    },
    caption: {
      fontSize: "12px", // 0.75rem
    },
    button: {
      fontSize: "14px", // 0.875rem
      textTransform: "none",
    },
  },

  //** OVERRIDES
  components: {
    MuiCheckbox: {
      defaultProps: {
        color: "secondary",
      },
    },
    MuiRadio: {
      defaultProps: {
        color: "secondary",
      },
    },
  },

  breakpoints: {
    values: {
      mobile: 0,
      tablet: 640,
      laptop: 1024,
      desktop: 1200,
    },
  },
});
